<template>
  <div
    class="authRegisterPage tw-grid lg:tw-grid-cols-[420px_1fr] 3xl:tw-grid-cols-[636px_1fr] 4xl:tw-grid-cols-[995px_1fr] tw-grid-cols-[1fr] tw-min-h-[100vh]"
  >
    <div
      class="tw-hidden lg:tw-flex tw-flex-col tw-justify-between tw-bg-main 4xl:tw-text-[24px] 3xl:tw-text-[18px] tw-text-[16px]"
    >
      <div class="tw-py-[40px] tw-px-[30px]">
        <img
          class="3xl:tw-w-[300px] 4xl:tw-w-[450px] tw-w-[200px] tw-mb-[30px]"
          :src="require(`@/assets/images/logo-white.svg`)"
        />
        <div class="tw-text-[#AFC3DD] tw-mb-[40px]">
          Платформа контроля транспорта<br />
          и управления арендой
        </div>
        <div class="tw-text-[#AFC3DD]">Российское программное обеспечение</div>
      </div>

      <img class="tw-w-full" :src="require(`@/assets/images/login-bg.png`)" />

      <div class="tw-py-[40px] tw-px-[30px]">
        <div class="tw-text-[#AFC3DD] tw-mb-[30px]">
          Использование без лицензионных платежей
        </div>
        <div class="tw-bg-[#AFC3DD] tw-h-[1px]"></div>
        <div
          class="tw-text-[#AFC3DD] tw-mt-[45px] 3xl:tw-mt-[58px] 4xl:tw-mt-[84px] tw-mb-[67px] 3xl:tw-text-[15px] 4xl:tw-text-[18px] tw-text-[12px]"
        >
          © 2011 - {{ new Date().getFullYear() }} Сириус. Все права защищены
        </div>
      </div>
    </div>
    <div
      class="tw-bg-[#F3F4F7] tw-w-full tw-grid tw-h-full tw-grid-rows-[1fr_auto] tw-px-[18px] lg:tw-px-0"
    >
      <div
        class="lg:tw-py-[20px] lg:tw-flex tw-items-center tw-justify-center tw-text-[12px] tw-text-[#5A697F]"
      >
        <!-- мобильная шапка -->
        <div class="lg:tw-hidden tw-text-center tw-my-[24px]">
          <img
            width="200"
            class="tw-mb-[15px]"
            :src="require(`@/assets/images/logo-dark.svg`)"
          />

          <div class="tw-mb-[20px]">
            Платформа контроля транспорта<br />
            и управления арендой
          </div>
          <div>Российское программное обеспечение</div>
        </div>
        <!-- мобильная шапка -->
        <div
          class="tw-relative tw-bg-white tw-py-[20px] lg:tw-py-[30px] tw-px-[15px] lg:tw-px-[45px] 4xl:tw-p-[45px] tw-rounded-[10px] tw-w-full tw-max-w-[520px] 3xl:tw-max-w-[620px] 4xl:tw-max-w-[720px] tw-text-[#5A697F] tw-mx-auto"
          :classxxx="{
            'tw-bg-white':
              $route.name !== 'AttemptRegistration' &&
              typeStepAuth != 'multiuser',
          }"
        >
          <!-- шапка формы -->
          <div
            v-if="typeStepAuth == 'multiuser'"
            class="tw-text-center --tw-mb-[20px]"
          >
            <div
              class="tw-text-[18px] lg:tw-text-[20px] 3xl:tw-text-[24px] 4xl:tw-text-[32px] tw-text-[#213960] tw-mb-[8px]"
            >
              Обнаружено несколько аккаунтов в системе
            </div>
            <div
              class="tw-text-[14px] lg:tw-text-[15px] 3xl:tw-text-[18px] 4xl:tw-text-[20px]"
            >
              Укажите SID компании, куда нужно войти!
            </div>
          </div>
          <div v-else class="tw-text-center">
            <div
              class="tw-text-[18px] lg:tw-text-[20px] 3xl:tw-text-[24px] 4xl:tw-text-[32px] tw-text-[#213960] tw-mb-[8px]"
            >
              {{ currentPathInfo.title }}
            </div>
            <div
              class="tw-text-[14px] lg:tw-text-[15px] 3xl:tw-text-[18px] 4xl:tw-text-[20px]"
            >
              {{ currentPathInfo.description }}
            </div>
          </div>
          <div
            v-if="
              $route.name !== 'AttemptRegistration' &&
              typeStepAuth != 'multiuser'
            "
            class="tw-mt-[25px] 4xl:tw-mt-[30px] tw-flex lg:tw-gap-[30px] lg:tw-px-[20px] tw-justify-between lg:tw-justify-center tw-border-0 tw-border-b-[1px] tw-border-solid tw-border-[#E3F0FF]"
          >
            <router-link
              v-for="(link, index) in links"
              :key="index"
              :to="link.link"
              class="focus-visible:tw-outline-none tw-text-[12px] lg:tw-text-[15px] 3xl:tw-text-[18px] 4xl:tw-text-[20px] !tw-text-[#023F8F] tw-whitespace-nowrap tw-border-0 tw-border-b-[3px] tw-border-solid tw-border-transparent tw-pb-[7px]"
              :class="{ '!tw-border-[#023F8F]': $route.path == link.link }"
            >
              {{ link.title }}
            </router-link>
          </div>
          <!-- шапка формы -->
          <!-- авторизация -->
          <div
            v-if="$route.path == '/auth' || $route.path == '/recovery-password'"
          >
            <div v-if="finishPasswordLoading">
              <BaseLoader class="tw-rounded-[10px]"></BaseLoader>
            </div>
            <!-- этап ввода email -->
            <div
              v-if="!typeStepAuth && $route.path == '/auth'"
              class="tw-pt-[15px] lg:tw-pt-[25px] 3xl:lg:tw-pt-[30px]"
            >
              <input
                type="email"
                v-model="authData.login"
                name="login"
                placeholder="E-mail (логин)"
                class="tw-app-input-auth"
                autocomplete="off"
              />
              <div
                class="tw-text-[12px] 3xl:tw-text-[14px] 4xl:tw-text-[18px] tw-my-[20px] tw-text-center tw-text-red-500"
                v-if="errorList.login"
                ref="descreg"
              >
                {{ errorList.login }}
              </div>
              <div
                class="3xl:tw-text-[14px] 4xl:tw-text-[18px] tw-text-[12px] tw-my-[15px] lg:tw-my-[25px] 3xl:tw-my-[30px] tw-text-center"
              >
                Забыли пароль?
                <router-link
                  to="/recovery-password"
                  class="!tw-text-[#213960] tw-underline"
                >
                  Восстановить
                </router-link>
              </div>
              <div class="tw-flex tw-justify-center">
                <button
                  class="tw-app-btn-auth lg:tw-min-w-[250px] 3xl:tw-min-w-[280px]"
                  @click="forwardAuth('login')"
                  :disabled="loading"
                >
                  Далее
                </button>
              </div>
            </div>
            <!-- этап ввода email -->
            <!-- этап ввода пароля -->
            <div
              v-show="typeStepAuth == 'permanent_password'"
              class="tw-pt-[15px] lg:tw-pt-[25px] 3xl:lg:tw-pt-[30px]"
            >
              <div>
                <input
                  type="password"
                  v-model="password"
                  name="permanent_password"
                  placeholder="Пароль"
                  class="tw-app-input-auth"
                  autocomplete="off"
                />
              </div>
              <div
                class="tw-text-[12px] 3xl:tw-text-[14px] 4xl:tw-text-[18px] tw-my-[20px] tw-text-center tw-text-red-500"
                v-if="errorList.permanentPassword"
                ref="descreg"
              >
                {{ errorList.permanentPassword }}
              </div>
              <div
                class="3xl:tw-text-[14px] 4xl:tw-text-[18px] tw-text-[12px] tw-my-[15px] lg:tw-my-[25px] 3xl:tw-my-[30px] tw-text-center"
              >
                Введите ваш пароль
              </div>
              <div
                class="tw-grid tw-grid-cols-2 tw-gap-[20px] tw-justify-center"
              >
                <button
                  class="tw-app-btn-auth-outline"
                  @click="reloadPage"
                  :disabled="loading"
                >
                  Назад
                </button>
                <button
                  class="tw-app-btn-auth"
                  @click="finishPassword"
                  :disabled="loading"
                >
                  Войти
                </button>
              </div>
            </div>
            <!-- этап ввода пароля -->
            <!-- этап выбора компании, если у юзера их несколько -->
            <div
              v-if="typeStepAuth == 'multiuser'"
              class="tw-pt-[15px] lg:tw-pt-[25px] 3xl:lg:tw-pt-[30px]"
            >
              <div class="custom-select-dark">
                <BaseSelect
                  class=""
                  placeholder="Компания"
                  selectLabel=""
                  deselectLabel=""
                  v-model="dataCompanies"
                  :options="dataListForCompanies"
                  label="label"
                >
                  <template #noOptions><span></span></template>
                </BaseSelect>
              </div>
              <div
                class="tw-text-[12px] 3xl:tw-text-[14px] 4xl:tw-text-[18px] tw-my-[20px] tw-text-center tw-text-red-500"
                v-if="errorList.multiuser"
                ref="descreg"
                v-html="errorList.multiuser"
              ></div>
              <div
                class="tw-text-[12px] 3xl:tw-text-[14px] 4xl:tw-text-[18px] tw-px-[10px] tw-text-center tw-my-[15px] 3xl:tw-my-[20px] 4xl:tw-my-[25px]"
              >
                Если у вас есть ненужный аккаунт -<br />
                напишите в поддержку - мы его удалим
              </div>
              <div
                class="tw-grid tw-grid-cols-2 tw-gap-[20px] tw-justify-center"
              >
                <button
                  class="tw-app-btn-auth-outline"
                  @click="reloadPage"
                  :disabled="loading"
                >
                  Назад
                </button>
                <button
                  class="tw-app-btn-auth"
                  @click="multiuserAuth"
                  :disabled="loading"
                >
                  Войти
                </button>
              </div>
            </div>
            <!-- этап выбора компании, если у юзера их несколько -->
            <!-- при одноразовом пароле -->
            <div
              v-if="typeStepAuth == 'onetime_password'"
              class="tw-pt-[15px] lg:tw-pt-[25px] 3xl:lg:tw-pt-[30px]"
            >
              <input
                type="password"
                v-model="oneTimePassword"
                placeholder="Пароль"
                name="onetime_password"
                autocomplete="off"
                class="tw-app-input-auth"
              />
              <div
                class="tw-text-[12px] 3xl:tw-text-[14px] 4xl:tw-text-[18px] tw-my-[20px] tw-text-center tw-text-red-500"
                v-if="errorList.onetime"
                ref="descreg"
                v-html="errorList.onetime"
              ></div>
              <div
                class="3xl:tw-text-[14px] 4xl:tw-text-[18px] tw-text-[12px] tw-my-[15px] lg:tw-my-[25px] 3xl:tw-my-[30px] tw-text-center"
              >
                Ваш разовый пароль отправлен на почту
              </div>
              <div class="tw-flex tw-justify-center">
                <button
                  class="tw-app-btn-auth lg:tw-min-w-[250px] 3xl:tw-min-w-[280px]"
                  @click="onetimePasswordAuth"
                  :disabled="loading"
                >
                  Войти
                </button>
              </div>
            </div>
            <!-- при одноразовом пароле -->
            <!-- с нового девайса -->
            <div
              v-if="typeStepAuth == 'device'"
              class="tw-pt-[15px] lg:tw-pt-[25px] 3xl:lg:tw-pt-[30px]"
            >
              <input
                type="password"
                v-model="codeForAccept"
                placeholder="Код подтверждения"
                name="device"
                autocomplete="off"
                class="tw-app-input-auth"
              />
              <div
                class="tw-text-[12px] 3xl:tw-text-[14px] 4xl:tw-text-[18px] tw-my-[20px] tw-text-center tw-text-red-500"
                v-if="errorList.device"
                ref="descreg"
              >
                {{ errorList.device }}
              </div>
              <div
                class="3xl:tw-text-[14px] 4xl:tw-text-[18px] tw-text-[12px] tw-my-[15px] lg:tw-my-[25px] 3xl:tw-my-[30px] tw-text-center"
              >
                Вы впервые входите с этого устройства. <br />
                Введите, пожалуйста, дополнительный проверочный код,<br />
                который отправлен на вашу почту
              </div>
              <div class="tw-flex tw-justify-center">
                <button
                  class="tw-app-btn-auth lg:tw-min-w-[250px] 3xl:tw-min-w-[280px]"
                  @click="deviceAuth"
                  :disabled="loading"
                >
                  Войти
                </button>
              </div>
            </div>
            <!-- с нового девайса -->
          </div>
          <!-- авторизация -->
          <!-- восстановление пароля -->
          <div v-if="$route.path == '/recovery-password'">
            <div
              v-if="!typeStepAuth"
              class="tw-pt-[15px] lg:tw-pt-[25px] 3xl:lg:tw-pt-[30px]"
            >
              <input
                type="text"
                v-model="authData.login"
                placeholder="E-mail (логин)"
                class="tw-app-input-auth"
                autocomplete="off"
              />
              <div
                class="tw-text-[12px] 3xl:tw-text-[14px] 4xl:tw-text-[18px] tw-my-[20px] tw-text-center tw-text-red-500"
                v-if="errorList.recovery"
              >
                {{ errorList.recovery }}
              </div>
              <div
                class="tw-mt-[25px] 3xl:tw-mt-[30px] tw-flex tw-justify-center"
              >
                <button
                  class="tw-app-btn-auth lg:tw-min-w-[250px] 3xl:tw-min-w-[280px]"
                  @click="forwardAuth('recovery')"
                  :disabled="loading"
                >
                  Получить новый пароль
                </button>
              </div>
            </div>
          </div>
          <!-- восстановление пароля -->
          <!-- регистрация -->
          <div
            v-if="
              $route.path == '/reg' && statusLoading !== 'success' && !loading
            "
          >
            <div class="tw-pt-[15px] lg:tw-pt-[25px] 3xl:lg:tw-pt-[30px]">
              <!-- временно скрыли выбор страны, сделали предвыбор россии в хуке mounted -->
              <!-- <div class="tw-mb-[10px] 3xl:tw-mb-[15px]">
                <BaseSelect
                  class="custom-select-dark"
                  placeholder="Страна"
                  selectLabel=""
                  deselectLabel=""
                  @input="
                    (data) => {
                      getSelectData(data, 'region');
                      clearValidation('country_id');
                    }
                  "
                  v-model="registData.country"
                  :options="optionSelect.countries"
                  label="countries__name"
                >
                  <template #noOptions><span></span></template>
                </BaseSelect>
                <div
                  ref="country_id"
                  class="tw-text-[12px] tw-text-red-500 tw-hidden"
                >
                  Указание страны обязательно
                </div>
              </div> -->

              <div class="tw-mb-[10px] 3xl:tw-mb-[15px]">
                <BaseSelect
                  class="custom-select-dark"
                  placeholder="Регион"
                  selectLabel=""
                  deselectLabel=""
                  @input="
                    (data) => {
                      getSelectData(data, 'city');
                      clearValidation('region_id');
                    }
                  "
                  v-model="registData.region"
                  :options="optionSelect.regions"
                  label="regions__name"
                >
                  <template #noOptions>Выберите страну</template>
                </BaseSelect>
                <div
                  ref="region_id"
                  class="tw-text-[12px] tw-text-red-500 tw-hidden"
                >
                  Указание региона обязательно
                </div>
              </div>

              <div class="tw-mb-[10px] 3xl:tw-mb-[15px]">
                <BaseSelect
                  class="custom-select-dark"
                  placeholder="Город"
                  selectLabel=""
                  deselectLabel=""
                  @input="
                    (data) => {
                      clearValidation('city_id');
                    }
                  "
                  v-model="registData.city"
                  :options="optionSelect.cities"
                  label="cities__name"
                >
                  <template #noOptions>
                    <div v-if="!getSelectDataCityLoading">
                      Выберите регион
                    </div>
                    <div v-if="getSelectDataCityLoading" class="tw-mb-[15px]">
                      Загрузка городов..
                    </div>
                  </template>
                </BaseSelect>
                <div
                  ref="city_id"
                  class="tw-text-[12px] tw-text-red-500 tw-hidden"
                >
                  Указание города обязательно
                </div>
                <div
                  v-if="getSelectDataCityHasError"
                  class="tw-text-[12px] tw-text-red-500"
                >
                  Ошибка при загрузке городов. Перевыберите регион
                </div>
              </div>

              <div class="tw-mb-[10px] 3xl:tw-mb-[15px]">
                <input
                  class="tw-app-input-auth"
                  type="text"
                  v-model="registData.login"
                  placeholder="E-mail (логин)"
                  @input="() => clearValidation('login')"
                />
                <div
                  ref="login"
                  class="tw-text-[12px] tw-text-red-500 tw-hidden"
                >
                  Указание электронной почты обязательно
                </div>
              </div>

              <div class="tw-mb-[10px] 3xl:tw-mb-[15px]">
                <BaseInputNew
                  inputClass="tw-app-input-auth"
                  placeholder="+7(___)___-__-__"
                  @input="updatePhone($event)"
                  :value="fakePhoneForMask"
                  inputMask="+{7}(000)000-00-00"
                  maxLength="16"
                  :additionalParams="{}"
                >
                  <template #label>
                    <span class="text-danger">*</span>
                  </template>
                </BaseInputNew>
                <div
                  ref="phone"
                  class="tw-text-[12px] tw-text-red-500 tw-hidden"
                >
                  Указание номера телефона обязательно
                </div>
              </div>
            </div>

            <div ref="descreg"></div>
            <input
              v-if="!$route?.query?.pr"
              class="tw-app-input-auth 3xl:tw-mt-[15px] tw-my-[5px]"
              type="text"
              v-model="registData.promo"
              placeholder="Промокод на премиум доступ (если есть)"
              @input="() => clearValidation('promo')"
            />
            <div
              class="tw-my-[20px] tw-text-[14px] lg:tw-text-[15px] 3xl:tw-text-[18px] 4xl:tw-text-[20px]"
              v-if="$route?.query?.pr"
            >
              Промокод на Сириус Pro (365 дней за 0 рублей) уже применен
            </div>

            <div class="tw-my-[15px] 3xl:tw-my-[30px]">
              <BaseCheckboxV3
                v-model="agree"
                @oncheckeds="agree = !agree"
                class="tw-items-start tw-cursor-pointer"
                :error="isAgreeError && !agree"
              >
                <span v-html="agreeTxt"></span>
              </BaseCheckboxV3>
            </div>

            <div class="tw-flex tw-justify-center">
              <button
                class="tw-app-btn-auth lg:tw-min-w-[250px] 3xl:tw-min-w-[280px]"
                @click="forwardReg"
              >
                Зарегистрироваться
              </button>
            </div>
          </div>
          <!-- -------- -->
          <!-- когда успешно зарегали о говорим о том что нужно подтвердить -->
          <div
            class="tw-text-center tw-my-[15px] lg:tw-my-[25px] tw-text-[12px] 3xl:tw-text-[14px] 4xl:tw-text-[18px] tw-px-[10px]"
            v-if="$route.path == '/reg' && statusLoading == 'success'"
          >
            <div v-if="successMessage" v-html="successMessage"></div>
            <div v-else>
              Завершите регистрацию по ссылке, отправленной на указанный вами
              e-mail.
            </div>
          </div>
          <!-- когда успешно зарегали о говорим о том что нужно подтвердить -->
          <!-- когда запрос в процессе отправки -->
          <div
            class="tw-text-center tw-my-[15px] lg:tw-my-[25px] tw-text-[12px] 3xl:tw-text-[14px] 4xl:tw-text-[18px] tw-px-[10px]"
            v-if="$route.path == '/reg' && loading"
          >
            Пожалуйста подождите.<br />
            Аккаунт создается
            <div class="tw-mt-[10px]">
              Если аккаунт не создается в течение 1 минуты или вам не приходит
              проверочное письмо - напишите нам на support@sirius.rent мы быстро
              вам поможем
            </div>
          </div>
          <!-- когда запрос в процессе отправки -->
          <!-- когда перешли из письма по ссылке -->
          <div
            v-if="
              isRegisterScenaryFromMail && $route.name == 'AttemptRegistration'
            "
            class="tw-text-center tw-my-[15px] lg:tw-my-[25px] tw-text-[12px] 3xl:tw-text-[14px] 4xl:tw-text-[18px] tw-px-[10px]"
          >
            <div v-if="isRegisterScenaryFromMailLoading">Загрузка...</div>
            <div v-else>
              {{ loadNewUserStatusMessage }}
            </div>
            <div
              v-if="!isRegisterScenaryFromMailLoading"
              class="tw-flex tw-justify-center tw-mt-[30px]"
            >
              <RouterLink to="/auth">
                <button
                  class="tw-app-btn-auth lg:tw-min-w-[250px] 3xl:tw-min-w-[280px]"
                >
                  Войти
                </button>
              </RouterLink>
            </div>
          </div>
          <!-- когда перешли из письма по ссылке -->
          <!-- восстановление пароля -->
          <div
            class="auth-layout-loader__desc"
            v-if="
              $route.path == '/recovery-password' && statusLoading == 'success'
            "
          >
            На вашу почту отправлены данные для входа.<br />
            Проверьте почту и вернитесь на форму авторизации
          </div>
          <!-- восстановление пароля -->
          <!-- регистрация -->
        </div>
      </div>
      <footer
        class="tw-hidden lg:tw-flex tw-grow tw-justify-between tw-px-[30px] tw-py-[45px] tw-text-[#5A697F] tw-text-[12px] 3xl:tw-text-[15px] 4xl:tw-text-[20px] tw-border-0 tw-border-t-[1px] tw-border-solid tw-border-[#EDEFF5]"
      >
        <div>
          <div class="tw-flex tw-gap-[10px] tw-mb-[8px]">
            <img
              width="11"
              :src="require(`@/assets/images/icons/lock-dark.svg`)"
            />
            Защищенное соединение TLS 1.3
          </div>
          <div>
            Информационная система внесена в реестр<br />
            российского программного обеспечения<br />
            Министерства цифрового развития РФ
          </div>
        </div>
        <div class="tw-flex tw-items-start tw-gap-[10px] tw-mb-[8px]">
          <img
            class="tw-mt-[3px]"
            width="14"
            :src="require(`@/assets/images/icons/support-dark.svg`)"
          />
          <div>
            <div>Служба поддержки</div>
            <a href="mailto:support@sirius.rent" class="!tw-text-[#5A697F]">
              support@sirius.rent
            </a>
          </div>
        </div>
        <div>Версия системы {{ version }}</div>
      </footer>

      <div class="lg:tw-hidden tw-text-center tw-text-[#5A697F] tw-text-[12px]">
        <div
          class="tw-flex tw-items-center tw-justify-center tw-gap-[10px] tw-mt-[26px] tw-mb-[15px]"
        >
          <img
            class="tw-mt-[2px]"
            width="14"
            :src="require(`@/assets/images/icons/support-dark.svg`)"
          />
          <div>Служба поддержки</div>
          <a href="mailto:support@sirius.rent" class="!tw-text-[#5A697F]">
            support@sirius.rent
          </a>
        </div>
        <div>Использование без лицензионных платежей</div>
      </div>
      <footer
        class="lg:tw-hidden tw-border-0 tw-border-t-[1px] tw-border-solid tw-border-[#EDEFF5] tw-py-[15px] tw-my-[15px] tw-text-[#5A697F] tw-text-[12px] tw-text-center"
      >
        © 2011 - {{ new Date().getFullYear() }} Сириус. Все права защищены
      </footer>
    </div>
  </div>
</template>

<script>
import AccessService from "@/api/AccessService";
import GeneralService from "@/api/GeneralService";
import IMask from "imask";
import { RouterLink } from "vue-router";
import { mapActions, mapState, mapMutations } from "vuex";
// import { VueRecaptcha } from 'vue-recaptcha'
import Vue from "vue";
import { VueReCaptcha } from "vue-recaptcha-v3";
// Vue.use(VueReCaptcha, { siteKey: '<site key>' })
import httpInstance from "@/http-common";
import router from "@/router";
import BaseCheckbox from "@/components/ui/BaseCheckbox.vue";
import BaseCheckboxV2 from "@/components/ui/BaseCheckboxV2.vue";
import BaseCheckboxV3 from "@/components/ui/BaseCheckboxV3.vue";
import { setTimeout } from "core-js";
export default {
  components: { BaseCheckboxV2, BaseCheckbox, BaseCheckboxV3 },
  // components: {
  //   gRecaptcha
  // },
  props: {},
  data() {
    return {
      getSelectDataCityLoading: false,
      getSelectDataCityHasError: false,
      emailRegex: /^\S+@\S+\.\S+$/,
      version: null,
      links: [
        {
          title: "Вход",
          link: "/auth",
          description: "Войдите в свой аккаунт для работы в системе",
        },
        {
          title: "Регистрация",
          link: "/reg",
          description: "Создайте аккаунт для работы в системе",
        },
        {
          title: "Восстановление пароля",
          link: "/recovery-password",
        },
      ],
      agreeLink: "",
      agreeTxt: "",
      agree: false,
      isAgreeError: false,
      loading: false,
      statusLoading: "",
      googleToken: null,
      oneTimePassword: "",
      photosOfBack: [],
      currentPhotoForBack: null,
      dataListForCompanies: [],
      dataCompanies: null,
      recoveryLogin: "",
      password: "",
      authData: {
        login: null,
        password: null,
      },
      recoveryData: {
        login: null,
      },
      registData: {
        login: "",
        phone: "",
        country: [],
        region: [],
        city: [],
        promo: "",
      },
      errorList: {
        login: "",
        multiuser: "",
        permanentPassword: "",
        recovery: "",
        onetime: "",
      },
      typeStepAuth: "",
      codeForAccept: "",
      optionSelect: {
        countries: [],
        regions: [],
        cities: [],
      },
      isRegisterScenaryFromMail: false,
      isRegisterScenaryFromMailLoading: false,
      isLoadNewUserStatus: null,
      loadNewUserStatusMessage: "",
      fakePhoneForMask: "",
      finishPasswordLoading: false,
    };
  },
  mounted() {
    this.registData.country = {
      countries__id: 1,
      countries__name: "Россия",
      countries__phone_mask: "+7(___)___-___-__",
      countries__language_id: 1,
      countries__currency_id: 1,
    };
    this.getSelectData(this.registData.country, "region");
    this.clearValidation("country_id");
  },
  methods: {
    ...mapActions("accessModule", ["reg", "auth"]),
    ...mapMutations("accessModule", ["auth_status"]),

    // updateToken(payload) {
    //   this.googleToken = payload.response_token
    // },
    updatePhone(e) {
      this.registData.phone = e.value;
      if (this.registData.phone.length == 16) {
        this.fakePhoneForMask = this.registData.phone;
      }
    },
    reloadPage() {
      window.location.href = window.location.href;
    },
    multiuserAuth() {
      if (this.dataCompanies) {
        this.loading = true;
        GeneralService.editOrCreate(
          this.authData.login && this.$route.path == "/recovery-password"
            ? "/employee/renewal"
            : `/employee/auth`,
          {
            company_id: this.dataCompanies.value,
            login: this.authData.login,
            ...(this.authData.password && { password: this.authData.password }),
          }
        )
          .then((data) => {
            if (data?.data?.action) {
              this.typeStepAuth = data.data.action;
            } else {
              if (this.$route.path == "/recovery-password") {
                this.$toast.success(data?.data?.message);
                router.push("/auth");
              } else {
                this.errorList.multiuser = "";
                router.push("/welcome");
              }
            }
          })
          .catch((e) => {
            this.errorList.multiuser = e.response.data.message;
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.errorList.multiuser = "Укажите компанию";
      }
    },
    onetimePasswordAuth() {
      if (this.oneTimePassword) {
        this.loading = true;
        GeneralService.editOrCreate(
          (this.authData.login || this.recoveryLogin) &&
            this.$route.path == "/recovery-password"
            ? "/employee/renewal"
            : `/employee/auth`,
          {
            password: this.oneTimePassword,
            login: this.authData.login,
            ...(this.dataCompanies?.value && {
              company_id: this.dataCompanies?.value,
            }),
          }
        )
          .then((data) => {
            if (data?.data?.action) {
              this.typeStepAuth = data.data.action;
            } else {
              this.errorList.login = "";
              localStorage.setItem(
                "user-token",
                JSON.stringify(data.data.token)
              );
              httpInstance.defaults.headers.common["X-Employee-Token"] =
                JSON.parse(localStorage.getItem("user-token"));
              localStorage.setItem("loginAt", new Date());
              router.push("/welcome");
            }
          })
          .catch((e) => {
            this.errorList.onetime = e.response.data.message;
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.errorList.login = "Заполните код, отправленный на почту";
      }
    },

    callback(token) {
      // google recaptcha token , then you can pass to backend with your form data .
      if (token) {
        alert(token);
      } else {
        // if you use data-size show reCAPTCHA , maybe you will get empty token.
        alert("please check you are not robot");
      }
    },
    clearValidation(name) {
      this.$refs[name]?.classList.remove("d-block");
      if (this.$refs.descreg) {
        this.$refs.descreg.textContent = "";
      }
    },
    deviceAuth() {
      if (this.codeForAccept) {
        this.loading = true;
        GeneralService.editOrCreate(
          (this.authData.login || this.recoveryLogin) &&
            this.$route.path == "/recovery-password"
            ? "/employee/renewal"
            : `/employee/auth`,
          {
            secret: this.codeForAccept,
            ...(!this.password && {
              password: this.authData.password,
            }),
            ...(this.oneTimePassword && {
              password: this.oneTimePassword,
            }),
            ...(this.password && {
              password: this.password,
            }),
            login: this.authData.login,
            ...(this.dataCompanies?.value && {
              company_id: this.dataCompanies.value,
            }),
          }
        )
          .then((data) => {
            if (data?.data?.action) {
              this.typeStepAuth = data.data.action;
            } else {
              this.errorList.login = "";
              localStorage.setItem(
                "user-token",
                JSON.stringify(data.data.token)
              );
              httpInstance.defaults.headers.common["X-Employee-Token"] =
                JSON.parse(localStorage.getItem("user-token"));
              localStorage.setItem("loginAt", new Date());
              router.push("/welcome");
            }
          })
          .catch((e) => {
            this.errorList.device = e.response.data.message;
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.errorList.device = "Заполните код, отправленный на почту";
      }
    },
    finishPassword() {
      if (this.password) {
        this.loading = true;
        GeneralService.editOrCreate(`/employee/auth`, {
          password: this.password,
          login: this.authData.login,
          ...(this.dataCompanies?.value && {
            company_id: this.dataCompanies.value,
          }),
        })
          .then((data) => {
            this.authData.password = this.password;
            if (data?.data?.action) {
              //this.typeStepAuth = data.data.action;
            } else {
              localStorage.setItem(
                "user-token",
                JSON.stringify(data.data.token)
              );
              httpInstance.defaults.headers.common["X-Employee-Token"] =
                JSON.parse(localStorage.getItem("user-token"));

              localStorage.setItem("loginAt", new Date());
              this.finishPasswordLoading = true;
              router.push("/welcome");
            }
          })
          .catch((e) => {
            this.finishPasswordLoading = false;
            this.errorList.permanentPassword = e.response.data.message;
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.errorList.permanentPassword = "Заполните поле пароль";
      }
    },

    forwardAuth(type) {
      // @type - recovery || login
      if (type == "recovery" && !this.emailRegex.test(this.authData.login)) {
        this.errorList.recovery = "Укажите корректный email";
        return;
      }
      if (this.authData.login || this.recoveryLogin) {
        this.loading = true;
        // this.$refs.descreg.textContent = ''
        GeneralService.editOrCreate(
          (this.authData.login || this.recoveryLogin) &&
            this.$route.path == "/recovery-password"
            ? "/employee/renewal"
            : `/employee/auth`,
          {
            login: this.authData?.login
              ? this.authData?.login
              : this.recoveryLogin,
          }
        )
          .then((data) => {
            this.typeStepAuth = data.data.action;
            if (this.typeStepAuth == "multiuser") {
              this.dataListForCompanies = data.data.data.map((el) => {
                return { label: el, value: el };
              });
            }
            if (
              !this.typeStepAuth &&
              this.$route.path == "/recovery-password"
            ) {
              this.$toast.success(data?.data?.message);
              router.push("/auth");
            }
            this.errorList.login = "";
          })
          .catch((e) => {
            if (this.$route.path == "/recovery-password") {
              this.errorList.recovery = e.response.data.message;
            } else {
              this.errorList.login = e.response.data.message;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        // this.auth_status('')
        this.errorList.login = "Поле E-mail является обязательными";
      }
    },
    forwardReg() {
      if (this.registData.login && this.registData.phone) {
        // сделаем проверку на оферту
        if (!this.agree) {
          this.isAgreeError = false;
          setTimeout(() => (this.isAgreeError = true), 100);
          this.$toast.error("Для регистрации нужно согласие с офертой", {
            duration: 0,
          });
          return;
        } else {
          this.isAgreeError = false;
        }
        // сделаем проверку на оферту
        this.loading = true;
        this.statusLoading = "";
        if (this.$refs.descreg) {
          this.$refs.descreg.textContent = "";
        }
        //костыль автовыбора России если он не сработал выше
        if (!this.registData.country) {
          this.registData.country = {
            countries__id: 1,
            countries__name: "Россия",
            countries__phone_mask: "+7(___)___-___-__",
            countries__language_id: 1,
            countries__currency_id: 1,
          };
        }
        //костыль автовыбора России
        this.reg({
          authData: {
            offerta_agreement: this.agree,
            login: this.registData.login,
            phone: this.registData.phone,
            country_id: this.registData.country.countries__id,
            region_id: this.registData.region.regions__id,
            city_id: this.registData.city.cities__id,
            link: window.location.href,
            promo: this.registData.promo,
          },
          callback: (stat, message, errors) => {
            if (stat == "error" && errors) {
              this.loading = false;
              let offerErr = errors?.offerta_agreement?.[0] ?? false;
              if (offerErr) this.$toast.error(offerErr, { duration: 0 });
              if (stat == "error" && message) {
                if (this.$refs.descreg) {
                  this.$refs.descreg.textContent = message;
                }
              }
              Object.keys(errors).forEach((elem, index) => {
                this.$refs[elem]?.classList.add("d-block");
              });
            }
            if (stat == "success") {
              this.statusLoading = "success";
              this.typeStepAuth = "";
            }
            this.loading = false;
          },
        });
      } else {
        this.$toast.error("Заполните все поля", { duration: 0 });
      }
    },
    forwardRecovery() {
      if (this.recoveryLogin) {
        this.loading = true;
        // this.$refs.descreg.textContent = ''
        GeneralService.editOrCreate(`/employee/renewal`, {
          login: this.recoveryLogin,
        })
          .then((data) => {
            this.typeStepAuth = data.data.action;
            if (this.typeStepAuth == "multiuser") {
              this.dataListForCompanies = data.data.data.map((el) => {
                return { label: el, value: el };
              });
            }
            this.errorList.recovery = "";
          })
          .catch((e) => {
            this.errorList.recovery = e.response.data.message;
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        // this.auth_status('')
        this.errorList.login = "Поле E-mail является обязательными";
      }
    },
    getSelectData(data, kind) {
      switch (kind) {
        case "region":
          this.registData.region = [];
          this.registData.city = [];
          GeneralService.get("/regions", {
            params: {
              where: JSON.stringify([
                { field: "regions__country_id", value: data.countries__id },
              ]),
            },
          }).then((data) => {
            this.optionSelect.regions = data.data.data.rows;
          });
          break;
        case "city":
          this.getSelectDataCityLoading = true;
          this.getSelectDataCityHasError = false;
          this.registData.city = [];
          this.optionSelect.cities = [];
          GeneralService.get("/cities", {
            params: {
              where: JSON.stringify([
                { field: "cities__region_id", value: data.regions__id },
              ]),
            },
          })
            .then((data) => {
              this.optionSelect.cities = data.data.data.rows;
              this.getSelectDataCityLoading = false;
            })
            .catch((data) => {
              this.getSelectDataCityLoading = false;
              this.getSelectDataCityHasError = true;
            });
          break;
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    // this.$refs.descreg.textContent = ''
    this.statusLoading = "";
    this.loading = false;
    for (const key in this.registData) {
      this.registData[key] = null;
    }
    this.fakePhoneForMask = "";
    this.oneTimePassword = "";
    this.dataListForCompanies = [];
    this.dataCompanies = null;
    this.recoveryLogin = "";
    this.password = "";
    this.authData = {
      login: null,
      password: null,
    };
    this.errorList = {
      login: "",
      multiuser: "",
      permanentPassword: "",
      recovery: "",
      onetime: "",
    };
    // костыль автовыбора России
    this.registData.country = {
      countries__id: 1,
      countries__name: "Россия",
      countries__phone_mask: "+7(___)___-___-__",
      countries__language_id: 1,
      countries__currency_id: 1,
    };
    this.getSelectData(this.registData.country, "region");
    this.clearValidation("country_id");
    // костыль
    (this.typeStepAuth = ""), (this.codeForAccept = ""), next();
  },
  computed: {
    ...mapState("accessModule", [
      "statusAuth",
      "statusReg",
      "loggedStatus",
      "authMessage",
      "regMessage",
      "successMessage",
    ]),
    currentPathInfo() {
      return this.links.find((i) => i.link == this.$route.path) || {};
    },
  },
  created() {
    // window.onloadCallback = () => {
    //   grecaptcha.render('html_element', {
    //     sitekey: '6LeVgwUrAAAAAA1bQLCVAMsd8QU_6u-GXiJEuOKE'
    //   })
    // }
    GeneralService.get("/open/offerta/text").then((res) => {
      this.agreeTxt = res.data.data.text;
      this.agreeLink = res.data.data.link;
    });
    GeneralService.get("/open/version").then((res) => {
      this.version = res.data.data.version;
    });
    GeneralService.get("/countries").then((data) => {
      this.optionSelect.countries = data.data.data.rows;
    });

    if (this.$route.name == "AttemptRegistration" && !!this.$route.hash) {
      this.isRegisterScenaryFromMail = true;
      this.isRegisterScenaryFromMailLoading = true;
      GeneralService.editOrCreate("/employee/attempt", {
        key: this.$route.hash.slice(1),
      })
        .then((data) => {
          this.$toast.success(data.data.message);
          this.isLoadNewUserStatus = true;
          this.loadNewUserStatusMessage = data.data.message;
        })
        .catch((e) => {
          console.error(e);
          this.$toast.error(e.response.data.message);
          this.isLoadNewUserStatus = false;
          this.loadNewUserStatusMessage = e.response.data.message;
        })
        .finally(() => {
          this.isRegisterScenaryFromMailLoading = false;
          // this.$router.push('/auth')
        });
    }

    // https://crmrent.com/attempt#1763556114
    // GeneralService.get('/cities').then((data) => {
    //
    //   this.optionSelect.cities = data.data.data.rows
    // })
    // GeneralService.get('/regions', {
    //   params: {}
    // }).then((data) => {
    //
    //   this.optionSelect.regions = data.data.data.rows
    // })
  },
};
</script>

<style lang="scss">
.authRegisterPage {
  a:hover {
    color: inherit;
  }
}
.custom-select {
  .multiselect__option.multiselect__option--highlight {
    background: #013f8f;
  }

  .multiselect__option {
    background: #fff;
  }

  .multiselect__content-wrapper {
    border: 0;
  }
  .multiselect__select {
    top: 9px;
    right: 5px;
  }

  .multiselect__tags {
    border: 0;
    height: 45px;
    padding: 12px 10px;
    font-size: 15px;
    border-radius: 5px;
  }

  span.multiselect__placeholder {
    margin: 0;
    padding: 0;
  }

  input.multiselect__input,
  span.multiselect__single {
    font-size: 15px;
    color: #5a697f;
  }
}
.custom-select-dark {
  .multiselect__option.multiselect__option--highlight {
    background: #013f8f;
  }

  .multiselect__option {
    background: #f3f4f7;
    border-bottom: 1px solid #5a697f17;
    font-size: 13px;
  }

  .multiselect__content-wrapper {
    border: 0;
  }
  .multiselect__select {
    top: 9px;
    right: 5px;
    z-index: 1;
  }

  .multiselect__tags {
    border: 0;
    height: 45px;
    padding: 14px 10px;
    font-size: 12px;
    border-radius: 5px;
    background: #f3f4f7;
  }

  span.multiselect__placeholder {
    margin: 0;
    padding: 0;
  }

  input.multiselect__input,
  span.multiselect__single {
    font-size: 12px;
    color: #213960;
    background: #f3f4f7;
  }
  input.multiselect__input::placeholder {
    color: transparent;
  }
  .multiselect__placeholder {
    color: #5a697f;
  }
}
@media (min-width: 1024px) {
  .custom-select-dark {
    .multiselect__tags {
      padding: 12px 10px;
      font-size: 15px;
    }
    input.multiselect__input,
    span.multiselect__single {
      font-size: 15px;
    }
  }
}
@media (min-width: 2560px) {
  .custom-select-dark {
    .multiselect__tags {
      height: 57px;
      padding: 15px;
      font-size: 18px;
    }
    .multiselect__option {
      font-size: 15px;
      padding: 15px;
    }
    input.multiselect__input,
    span.multiselect__single {
      font-size: 18px;
      line-height: 27px;
    }
    .multiselect__select {
      top: 14px;
      right: 10px;
    }
  }
}
/* @media (min-width: 2560px) {
  .custom-select-dark {
    .multiselect__tags {
      height: 60px;
      font-size: 20px;
    }
    .multiselect__option {
      font-size: 15px;
    }
    input.multiselect__input,
    span.multiselect__single {
      font-size: 20px;
    }
    .multiselect__select {
      top: 14px;
      right: 10px;
    }
  }
} */
/* ssssssssss */
.agreement > .base-checkbox__sign {
  letter-spacing: 0;
  color: black;
  font-weight: 400;
  font-size: 12px;
  line-height: 125%;
  a {
    color: black;
    text-decoration: underline;
  }
}

.auth-box {
  width: 100%;
}

.auth-list-input {
  width: 100%;
}

.button-captcha {
  button {
    appearance: none;
    border: none;
    background: none;
    width: 100%;
    padding-top: 35px;
  }
}

.auth-layout-loader {
  position: fixed;
  right: 0;
  left: 0;
  bottom: 0;
  top: 0;
  background-color: rgba($color: #000000, $alpha: 0.4);
  transition: background-color 0.3s ease;
  z-index: 10000;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 20px;
  text-align: center;

  &__desc {
    text-align: center;
    font-weight: 400;
    font-size: 12px;
    color: black;
  }

  .spinner {
    position: static;
  }
}

.auth-desc-reg-about {
  font-size: 14px;
  line-height: 17.5px;
  text-align: center;
  margin-bottom: 30px;
  color: black;
}

.auth-reg-field {
  color: #fb5959;
  font-size: 14px;
  text-align: center;
  display: none;
}

.auth-desc-text {
  font-size: 14px;
  text-align: center;
  margin-bottom: 10px;
  color: #fb5959;
}

.auth-list-input {
  display: flex;
  gap: 15px;
  flex-direction: column;
  margin-bottom: 30px;
}

.auth-input {
  width: 100% !important;
  background-color: #f9f9f9 !important;
  border: 1px solid #cacaca !important;
  outline: 0 !important;
  font-size: 12px !important;
  line-height: 15px !important;
  padding: 11px !important;
  padding-left: 6px !important;
  color: black !important;
}

.auth-input::placeholder {
  color: black;
}

.auth-controls-list-under-input {
  display: flex;
  justify-content: center;
}

.auth-button {
  padding: 8px 50px;
  background-color: #114bd4;
  border-radius: 5px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  cursor: pointer;
  user-select: none;
  color: white;
}

.auth-layout {
  display: flex;
  height: 100vh;

  &__to-side {
    width: 100%;
  }

  &__left-side {
    flex-grow: 1;
    height: 100%;
    display: flex;
    align-items: center;
    position: relative;
    background: radial-gradient(
      53.59% 58.59% at 50% 50%,
      #0033a4 0%,
      #001962 46.61%,
      #00093a 100%
    );
    background-position: right center;
    background-size: cover;

    img {
      // position: absolute;
      // top: 0;
      // left: 0;
      width: 100%;
    }
  }

  &__right-side {
    width: 100%;
    max-width: 420px;
    padding: 23px 30px;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: white;
    flex-direction: column;
  }

  @media (max-width: 768px) {
    &__right-side {
      width: 100vw;
      justify-content: center;
      flex-direction: column;
      justify-content: space-between;
    }

    &__left-side {
      display: none;
    }
  }
}

@media (max-width: 768px) {
  .auth-layout {
    justify-content: center;
    overflow-y: scroll;
  }
}

.auth-list-link {
  margin-bottom: 15px;

  ul {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    gap: 20px;
    justify-content: center;
  }

  li a {
    display: block;
    padding-bottom: 7px;
    font-size: 12px;
    color: #0066b3;
    line-height: 15px;
  }

  li a.router-link-active {
    border-bottom: 3px solid #0066b3;
  }
}
</style>
